import apiEndPointsList from "../constant/apiEndPointsList";
import { basePost } from "@/utils/api/base";

const contactService = {
    sendContactForm: async (payload) => {
        const response = await basePost({
            endpoint: apiEndPointsList.contact.SEND_CONTACT_FORM,
            body: payload,
        });
        if (response.status < 200 || response.status >= 300) {
            throw new Error(response.data?.error || 'Gửi thất bại');
        }
        return response.data;
    },
};

export default contactService;
